import { observer } from "@legendapp/state/react";
import { AuthService } from "_services/auth.service";
import { Button } from "_ui/Button";

export const LoggedAsTopBard = observer(() => {
    if (!AuthService.$isLoggedAs.get()) {
        return null;
    }

    const currentUser = AuthService.$currentUser.get();

    if (!currentUser) {
        return null;
    }

    const backToAdmin = () => {
        AuthService.backToAdmin();
    }


    const currentCorut = AuthService.$courtSelected.get();
    const court = currentUser.courts?.find( _ => _.id == currentCorut) ?? { name: '', county: { name: '' } };

    return (<>
        <div className='top-logged-as'>
        </div>
        <div className="flex-wrap fixed-top text-white p-2 d-flex justify-content-sm-between justify-content-center g-sm-0 g-2 align-items-center" style={{ background: '#333' }}>
            <span>Logado na <b>{court.name}</b> da comarca <b>{court.county?.name}</b>.</span>
            <Button variant='secondary' icon='fa-arrow-left-to-bracket' text='Voltar ao adminstrativo' onClick={backToAdmin} />
        </div>
    </>
    );
});
